import { render, staticRenderFns } from "./NoInternet.vue?vue&type=template&id=865b8c0c"
import script from "./NoInternet.vue?vue&type=script&lang=js"
export * from "./NoInternet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports